import React, {useState} from 'react';
import './Editable.css';
import 'react-phone-number-input/style.css'
import {Editable, EditableProps} from "./Editable";
import PhoneInput, {formatPhoneNumber} from "react-phone-number-input";
import {useEditable} from "./EditableContext";
import {isMobileNumberVerified} from "../../util/ContactUtil";
import {useProfile} from "../../UserProfileProvider";
import {VerifyContactMethodOverlay} from "./VerifyContactMethodOverlay";
import {space} from "../../compiled";
import ContactMethodType = space.kenko.proto.ContactMethodType;

export const EditableVerifiedPhoneInputField = <EnclosingType extends object>(props: EditableProps<EnclosingType, string>) => {

  const {editing, mode, value, setValue} = useEditable(props);

  const {profile} = useProfile();
  
  // If they clicked the verify button!!
  const [isVerifying, setIsVerifying] = useState(false);

  const isVerified = isMobileNumberVerified(profile)

  if (editing) {
    return <Editable {...props}>
      <PhoneInput
          placeholder="Enter phone number"
          defaultCountry={'US'}
          value={value ?? ''}
          onChange={v => {
            setValue(v as string);
          }}/>
    </Editable>

  } else {

    return <Editable {...props}>
      <div className={'EditableNotEditing'}>
        {value && formatPhoneNumber(value)} {value && (isVerified ? '[verified]' : <>[not verified] [<a
          style={{cursor: 'pointer', textDecoration: 'underline'}} onClick={() => setIsVerifying(true)}>verify
        now</a>]</>)}
      </div>

      {isVerifying && <VerifyContactMethodOverlay
          type={ContactMethodType.MOBILE_PHONE}
          value={value}
          onDone={() => {setIsVerifying(false)}}/>}

    </Editable>
  }

}